export default __webpack_public_path__ + "./image/2a178fa843401f00419eb8d004be1991.png";